<template>
  <div>
    <!-- Block 2: Input Text -->

    <div class="form-control" v-if="q.type == 'text'">
      <div class="onehalf first">
        <label :name="q.variable">{{ q.text }}</label>
      </div>
      <div class="onehalf second">
        <input
          :name="q.variable"
          type="text"
          :value="getAnswer(q.variable)"
          @input="
            (event) => {
              updateAnswer(q.variable, event.target.value);
            }
          "
        />
      </div>
    </div>

    <!-- Block 4: Sortable -->
    <div class="form-control sortable" v-if="q.type == 'order'">
      <label name="gender">{{ q.text }}</label>
      <two-list :list-one-items="q.answers" :answers-key="q.variable" />
      <span class="hint widescreen"
        >Ziehen Sie die Einträge vom linken ins rechte Feld</span
      >
      <span class="hint narrowscreen"
        >Ziehen Sie die Einträge vom oberen in das untere Feld</span
      >
    </div>

    <!-- Block 1: Radio Buttons -->
    <div class="form-control" v-if="q.type == 'radio'">
      <div class="onehalf first">
        <label name="gender">{{ q.text }}</label>
      </div>
      <div class="onehalf second">
        <fieldset v-for="e in q.answers" :key="e.text">
          <div class="radio-control">
            <label
              ><input
                class="radio"
                type="radio"
                :id="e.text"
                :name="q.variable"
                :value="e.value"
                @input="
                  (event) => {
                    updateAnswer(q.variable, event.target.value);
                  }
                "
                autocomplete="off"
                :checked="isSelected(q.variable, e)"
              />{{ e.text }}</label
            >
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Block 3: Option -->
    <div class="form-control" v-if="q.type == 'select'">
      <div class="onehalf first">
        <label name="gender">{{ q.text }}</label>
      </div>

      <div class="onehalf second">
        <selectric-component
          class="form-select"
          :name="q.variable"
          :id="q.variable"
          @input="
            (e) => {
              updateAnswer(q.variable, e);
            }
          "
        >
          <option value="">Eine Option wählen.…</option>
          <option
            v-for="e in q.answers"
            :value="e.value"
            :selected="isSelected(q.variable, e)"
            :key="e.value"
          >
            {{ e.text }}
          </option>
        </selectric-component>
      </div>
    </div>

    <!-- Block 5: Scale -->
    <div class="form-control" v-if="q.type == 'radiogrid'">
      <!-- desktop only -->
      <div v-if="!isMobile" class="widescreen">
        <table :class="q.multilabels ? 'multilabel' : ''">
          <tbody>
            <tr>
              <th colspan="9">{{ q.text }}</th>
            </tr>
            <tr>
              <td></td>
              <td
                v-for="n in getRange(q.minscale, q.maxscale)"
                :key="q.variable + '_th_' + n"
              >
                <!-- <strong>{{ Math.abs(parseInt(n)) }}</strong> -->
                <strong>{{ n }}</strong>
              </td>
              <td v-if="q.multilabels"></td>
            </tr>
            <tr v-for="e in q.answers" :key="e.variable">
              <td v-if="!q.multilabels">{{ e.text }}</td>
              <td v-if="q.multilabels">{{ e.textleft }}</td>
              <td
                v-for="n in getRange(q.minscale, q.maxscale)"
                :key="e.variable + '_' + n"
              >
                <input
                  class="radiogrid"
                  type="radio"
                  :id="e.variable + '_id_' + n"
                  :name="e.variable"
                  :value="n"
                  @input="
                    (event) => {
                      updateAnswer(e.variable, event.target.value);
                    }
                  "
                  autocomplete="off"
                  :checked="isGridSelected(e.variable, n)"
                />
              </td>
              <td v-if="q.multilabels">{{ e.textright }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- mobile only -->
      <div v-if="isMobile" class="narrowscreen">
        <table>
          <tbody>
            <tr>
              <th>{{ q.text }}</th>
            </tr>
            <tr v-for="e in q.answers" :key="e.variable">
              <td>
                <div v-if="!q.multilabels" class="row">{{ e.text }}</div>
                <div v-if="q.multilabels" class="row">
                  {{ e.textleft }} / {{ e.textright }}
                </div>
                <div class="row">
                  <div class="cell">
                    {{ q.minscale }}
                  </div>
                  <div
                    class="cell"
                    v-for="n in getRange(q.minscale, q.maxscale)"
                    :key="e.variable + '_' + n"
                  >
                    <input
                      type="radio"
                      :id="e.variable + '_id_' + n"
                      :name="e.variable"
                      :value="n"
                      @input="
                        (event) => {
                          updateAnswer(e.variable, event.target.value);
                        }
                      "
                      autocomplete="off"
                      :checked="isGridSelected(e.variable, n)"
                    />
                  </div>
                  <div class="cell">
                    {{ q.maxscale }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- <tr>
              <td>
                {{ q.minscale }}
              </td>
              <td
                v-for="n in getRange(q.minscale, q.maxscale)"
                :key="e.variable + '_' + n"
              >
                <input
                  type="radio"
                  :id="e.variable + '_id_' + n"
                  :name="e.variable"
                  :value="n"
                  @input="
                    (event) => {
                      updateAnswer(e.variable, event.target.value);
                    }
                  "
                  autocomplete="off"
                  :checked="isGridSelected(e.variable, n)"
                />
              </td>
              <td>
                {{ q.maxscale }}
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import selectricComponent from "@/components/Selectric.vue";
import TwoList from "@/components/TwoList.vue";

const props = {
  name: "question-displayer",
  q: {
    required: true,
  },
};
export default {
  components: {
    selectricComponent,
    TwoList,
  },
  props,
  data() {
    return { windowWidth: window.innerWidth };
  },
  mounted() {
    $("input.selectric-input").attr("readonly", true);
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },

  computed: {
    valueString() {
      return JSON.stringify(this.q, null, 2);
    },
    isMobile() {
      return this.windowWidth <= 540;
    },
  },
  methods: {
    isSelected: function (v, e) {
      if (this.getAnswer(v) == e.value) return true;
      else if (
        this.getAnswer(v) == null &&
        typeof e.default !== "undefined" &&
        e.default === true
      )
        return true;
      else return false;
    },
    isGridSelected: function (v, e) {
      //console.log(window.innerWidth);
      if (this.getAnswer(v) == e) return true;
      else return false;
    },
    updateAnswer: function (k, v) {
      this.$store.commit("updateAnswer", { key: k, value: v });
    },
    getAnswer: function (k) {
      return this.$store.getters.getAnswers[k];
    },
    getRange: function (start, end, step = 1) {
      const result = [];
      for (let i = start; i <= end; i += step) {
        result.push(i);
      }
      return result;
    },
  },
};
</script>

<style scoped>
/*
ul li {
  line-height: 24px;
}
/** */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(50px);
  opacity: 0;
}
/*
.radio-label {
  margin-bottom: 8px;
  width: 220px;
}
.radio-label-2 {
  margin-bottom: 8px;
  width: 250px;
}
/** */
</style>
